import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { adminLogin } from "../../../reducers/commonReducer";

const schema = yup.object().shape({
  username: yup.string().required(),
  password: yup.string().required(),
});

const UserLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if(localStorage.getItem("x-auth-token")){
      navigate(`/users`)
    }
  }, [])
  return (
    <>
      <div className="container-fluid">
        <div className="page-main p-5 mbl-pedding-10">
          <Row className="coloum-reverse-mbl">
            <Col md={6} className="mt-2 m-auto">
              <div className="border-y mb-4 text-center">
                <img src={process.env.REACT_APP_LOGO} alt="logo" title={process.env.REACT_APP_TITLE}/>
              </div>
              <Formik
                validationSchema={schema}
                onSubmit={async (values) => {
                    try {
                      const apiResp = await dispatch(adminLogin(values)).unwrap();
                      if (apiResp?.status) {
                        navigate(`/users`);
                      }
                    } catch (error) {
                      console.error("Login failed:", error);
                    }
                  }}

                // onSubmit={async (values) => {
                //   const apiResp = await dispatch(adminLogin(values));
                //   if (apiResp?.payload?.status) {
                //     navigate(`/users`);
                //   }
                // }}
                initialValues={{
                  username: "",
                  password: "",
                }}
              >
                {({ handleSubmit, handleChange, touched, values, errors }) => (
                  <Form className="container" onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Email/Phone</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Email/Phone"
                            name="username"
                            value={values.username}
                            onChange={handleChange}
                            isInvalid={!!errors.username}
                            className={
                              errors.username && touched.username && "errors"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.username}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Password</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Password"
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            isInvalid={!!errors.password}
                            className={
                              errors.password && touched.password && "errors"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.password}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button
                      variant="success"
                      className="bg-thememain w-100"
                      type="submit"
                    >
                      <i className="bi bi-unlock-fill"></i> Login
                    </Button>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default UserLogin;
